import React from 'react';
import useDownloadLink from "v4/components/utils/DownloadLink/hooks/useDownloadLink";
import {usePolTranslation} from "v4/hooks/usePolTranslation";

export default function DownloadLink({fileName, href, className = "", title, children}) {
    const {t} = usePolTranslation();
    const {handleClick, isLoading, preventClick} = useDownloadLink({fileName});
    const finalTitle = title === undefined ? t('download') : title;

    return (
        <a href={href}
           className={`${className} ${isLoading ? 'disabled' : ''}`}
           onClick={isLoading ? preventClick : handleClick}
           title={finalTitle}>
            {children}
        </a>
    )
}
